/**
 * @description 添加m1.lizhiweike.com备用域名，如果使用的是备用域名访问页面则接口也使用该域名请求数据
 */
// export const appBaseUrl = location.host === 'm1.lizhiweike.com' ? 'https://m1.lizhiweike.com' : 'https://m.lizhiweike.com'
declare const window: any

const PRESET_MAIN_URL = window && window.Session && window.Session.preset_config && window.Session.preset_config.mainUrl

export const appBaseUrl = PRESET_MAIN_URL || 'https://m.lizhiweike.com'



// WEBPACK FOOTER //
// ./src/config/index.ts